module.exports = __webpack_public_path__ + "img/male-anatomy.1bcfc9db.png";